import { AnyObject } from '../types';

export function toNumber(value: AnyObject): number {
  return Number.parseFloat(value);
}
